import { configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import authReducer from "./authSlice"
import sitesReducer from "./sitesSlice"
import userSitesReducer from "./userSitesSlice"
import schedulesReducer from "./schedulesSlice"
import bookingsReducer from "./bookingsSlice"
import clientsReducer from "./clientsSlice"
import chargersReducer from "./chargersSlice"
import scheduleColorsReducer from "./scheduleColorsSlice"

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user", "accessToken"], // Only persist the auth slice (add other slices here if needed)
}

const store = configureStore({
  reducer: {
    auth: persistReducer(persistConfig, authReducer),
    sites: sitesReducer,
    userSites: userSitesReducer,
    schedules: schedulesReducer,
    bookings: bookingsReducer,
    clients: clientsReducer,
    chargers: chargersReducer,
    scheduleColors: scheduleColorsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
})

export const persistor = persistStore(store)
export default store